import { EnergyTypeDto } from '@eneco/dc-be/client';
import { ElectricityIcon, GasIcon } from '@eneco/sparky/icons';

export const EnergyIcon = ({
  energyType,
  size = 'small',
}: {
  energyType: EnergyTypeDto;
  size: 'small' | 'medium' | 'large' | 'extraLarge';
}) => {
  if (energyType === 'Electricity')
    return <ElectricityIcon color="iconElectricity" size={size} verticalAlign="middle" />;
  return <GasIcon color="iconGas" size={size} verticalAlign="middle" />;
};
